export const parseStoredData = (input: string) => {
  if (typeof window === "undefined") return null;
  return JSON.parse(input);
};

export const getFormOneDataFromLocal = (
  key: string,
): { status: boolean; data: any; isMilesSection?: boolean } => {
  if (typeof window === "undefined") {
    return {
      status: false,
      data: "",
      isMilesSection: false,
    };
  }

  const localData = localStorage.getItem(key);

  if (localData) {
    try {
      const parsed = parseStoredData(localData);
      return {
        status: true,
        data: parsed,
        isMilesSection: parsed?.isMilesSection || false,
      };
    } catch (error) {
      return {
        status: false,
        data: "",
        isMilesSection: false,
      };
    }
  }
  return {
    status: false,
    data: "",
    isMilesSection: false,
  };
};

export const clearFromOneDataFromLocal = (key: string) => {
  if (typeof window !== "undefined") {
    localStorage.removeItem(key);
  }
};
